import { NotificationPreferenceRegister, useAuthentication } from '@ecosystem/newron-client-lib';
import { useEffect, useRef } from 'react';
import { RetailUpdates } from '../RetailUpdates';
import { GroupSharingNotification } from '../GroupSharingNotification';
import { NotificationSection } from '@ecosystem/newron-client-lib/build/preferences/notifications/types';
import { useSubscriptions } from '@components/subscriptions/SubscriptionsProvider';
import { ProductType } from '@pages/product-analyzer/Product';
import { getSubscriptionWithProductType } from '@utils/SubsciptionsUtils';
import { OpaSubscription } from '@models/Opa';

function hasValidRestrictions(subscription: OpaSubscription): boolean {
  return Boolean(subscription?.result?.restrictions?.length && subscription.result.restrictions.length > 0);
}

export const UseRegisterNotificationPreference = () => {
  const { isAuthenticated } = useAuthentication();
  const { subscriptions, loadingSubscriptions } = useSubscriptions();

  const registeredRef = useRef(false);

  useEffect(() => {
    (async () => {
      if (!isAuthenticated || loadingSubscriptions || registeredRef.current) {
        return;
      }

      const registry = NotificationPreferenceRegister.getInstance();
      const existingTypes = registry.getAll().map((s) => s.type);

      registeredRef.current = true;

      const performanceAnalyzerSubscription = getSubscriptionWithProductType(
        subscriptions,
        ProductType.PerformanceAnalyzer,
      );
      const productAnalyzerSubscription = getSubscriptionWithProductType(subscriptions, ProductType.ProductAnalyzer);
      const marketPremiumSubscription = getSubscriptionWithProductType(subscriptions, ProductType.MarketPremium);
      const sellerInsightsSubscription = getSubscriptionWithProductType(subscriptions, ProductType.SellerInsights);
      const retailKadSubscription = getSubscriptionWithProductType(subscriptions, ProductType.RetailKad);

      const hasValidSubscription =
        hasValidRestrictions(performanceAnalyzerSubscription) ||
        hasValidRestrictions(productAnalyzerSubscription) ||
        hasValidRestrictions(marketPremiumSubscription) ||
        hasValidRestrictions(sellerInsightsSubscription) ||
        hasValidRestrictions(retailKadSubscription);

      if (hasValidSubscription) {
        if (!existingTypes.includes('retail-updates')) {
          registry.register({
            group: 'data-updates',
            type: 'retail-updates',
            order: 400,
            component: RetailUpdates as NotificationSection,
          });
        }

        if (!existingTypes.includes('shared-groups')) {
          registry.register({
            group: 'shared-objects',
            type: 'shared-groups',
            order: 500,
            component: GroupSharingNotification as NotificationSection,
          });
        }
      }
    })();
  }, [isAuthenticated, loadingSubscriptions, subscriptions]);
};
